import {UI} from "../../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../stem-core/src/ui/Style";
import {Flow} from "../../initializeFlows";
import {LoadingSpinner} from "../../../ui/LoadingSpinner";
import {DONATE_PAGE_URLS} from "../../PanelConstants";
import {Messages} from "../../../Messages";
import {Link} from "../../../../stem-core/src/ui/UIPrimitives";
import {MerchantButton} from "../../../common/MerchantButton";
import {PoweredByBlink} from "../../PoweredByBlink";
import {PaymentMethodStore} from "../../../../client/state/PaymentMethodStore";
import {DonationStore} from "../../../../client/state/DonationStore";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {DonateHomeEditDonationComponent} from "./DonateHomeEditDonationComponent";
import {UsingCardComponent} from "../../pages/panels/payment-method/components/UsingCardComponent";
import {iFrameUserDataService} from "../../../services/IFrameUserDataService";
import {MessageElement} from "../../../widget/ui/MessageElement";
import {Controller} from "../../Controller";


class EditDonationPanelStyle extends StyleSheet {
    @styleRule
    button = this.themeProps.DONATE_PAGE_BUTTON;

    @styleRule
    title = {
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
        fontSize: 24,
        marginBottom: 20,
    };

    @styleRule
    description = {
        display: "inline",
    };

    @styleRule
    inlineLink = {
        ...this.themeProps.DONATE_PAGE_LINK,
        color: this.themeProps.MERCHANT_LINK,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        display: "inline-block",
        marginBottom: 20,
    };

    @styleRule
    back = this.themeProps.DONATE_PAGE_LINK;

    @styleRule
    center = {
        margin: "20px 0",
        textAlign: "center",
    };
}

@registerStyle(EditDonationPanelStyle)
export class EditDonationPanel extends UI.Element {
    isButtonDisabled() {
        const donation = iFrameUserDataService.getActiveRecurringDonation();
        return !(Flow.donation.isValid()
            && (Flow.donation.donationAmount !== donation.computeAmount()
                || Flow.donation.payDonationFeeCheckboxChecked !== donation.isDonationFeePaid()
                || donation.getPaymentMethod() !== Controller.paymentMethod.selectedPaymentMethod));
    }

    updateDonation() {
        LoadingSpinner.show();
        this.editDonationComponent.updateDonation();
    }

    render() {
        const {styleSheet} = this;

        const donation = iFrameUserDataService.getActiveRecurringDonation();

        Controller.paymentMethod.initialPaymentMethod = Controller.paymentMethod.selectedPaymentMethod;

        return [
            <div className={styleSheet.title}>{Messages.editDonationInlineTitle}</div>,
            <div>
                <MessageElement className={styleSheet.description}
                                message={Messages.donatePageRecurringDonationMessage(donation.formatPrice())}/>
                <Link value={Messages.here} className={styleSheet.inlineLink}
                      onClick={() => this.options.changeURL(DONATE_PAGE_URLS.cancelDonation)}/>.
            </div>,
            <UsingCardComponent card={Controller.paymentMethod.selectedPaymentMethod} hideTitle={true}
                                onChangeCard={() => this.options.changeURL(DONATE_PAGE_URLS.editChooseCard, true)}
                                changeCardMessage={Messages.edit} />,
            <DonateHomeEditDonationComponent ref="editDonationComponent" changeURL={this.options.changeURL}
                                             onChange={() => this.redraw()}/>,
            <MerchantButton label={Flow.donation.getDonatePageEditDonationComponentButtonLabel()}
                            disabled={this.isButtonDisabled()} onClick={() => this.updateDonation()}
                            className={styleSheet.button} ref="button"/>,
            <div className={styleSheet.center}>
                <Link value={Messages.back} className={styleSheet.back}
                      onClick={() => this.options.changeURL(DONATE_PAGE_URLS.recurringDonor, true)}/>
            </div>,
            <PoweredByBlink className={styleSheet.blinkLogo}/>,
        ];
    }

    onMount() {
        super.onMount();

        this.redraw(); // We need this first redraw because we have interdependent components
        this.attachChangeListener(PaymentMethodStore, () => {
            if (this.isInDocument()) {
                this.redraw()
            }
        });
        this.attachChangeListener(DonationStore, () => {
            if (this.isInDocument()) {
                if (!iFrameUserDataService.getActiveRecurringDonation()) {
                    this.options.changeURL(DONATE_PAGE_URLS.donate, true);
                } else {
                    this.redraw();
                }
            }
        });
    }
}
